import LogoUGS from "../../assets/img/logotipo.png";
import "../../components/header/Header.css";
import React, { useState } from "react";
import "../button/Button.css";
import { HiMenu } from "react-icons/hi";
import { CgClose } from "react-icons/cg";

export const Header = ({ changeFormType }) => {
  const wallgreen = "wallgreen";
  const growgreen = "growgreen";

  const [activeButton, setActiveButton] = useState(wallgreen);
  const [sideMenu, setSideMenu] = useState("hidden");

  const handleBtnWallGreen = () => {
    changeFormType(wallgreen);
    setActiveButton(wallgreen);
  };

  const handleBtnGrowGreen = () => {
    changeFormType(growgreen);
    setActiveButton(growgreen);
  };

  const handleSideMenu = () => {
    setSideMenu((s) => (s === "hidden" ? "visible" : "hidden"));
  };
  return (
    <header>
      <div className="div-logo">
        <img src={LogoUGS} alt="logo UGS" />
      </div>

      <nav className="navbar">
        <button
          className={`btn-accent-outlined ${
            activeButton === wallgreen ? "accent-active" : ""
          }`}
          onClick={handleBtnWallGreen}
        >
          WallGreen
        </button>
        <button
          className={`btn-accent-outlined ${
            activeButton === growgreen ? "accent-active" : ""
          }`}
          onClick={handleBtnGrowGreen}
        >
          Grow Green
        </button>
      </nav>
      <nav className="mobile-nav">
        <HiMenu onClick={handleSideMenu} className="menu-icon" />
      </nav>

      <div className={`side-menu ${sideMenu}`}>
        <CgClose className="menu-icon-x" onClick={handleSideMenu} />
        <h4>Escolha o sistema para cálculo:</h4>
        <div className="side-nav">
          <button
            className={`btn-accent-outlined ${
              activeButton === wallgreen ? "accent-active" : ""
            }`}
            onClick={() => {
              handleBtnWallGreen();
              handleSideMenu(); // Feche o menu ao clicar em um item
            }}
          >
            WallGreen
          </button>
          <button
            className={`btn-accent-outlined ${
              activeButton === growgreen ? "accent-active" : ""
            }`}
            onClick={() => {
              handleBtnGrowGreen();
              handleSideMenu(); // Feche o menu ao clicar em um item
            }}
          >
            Grow Green
          </button>
        </div>
      </div>
    </header>
  );
};
